import { useSuspenseQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { AxisRoleMap } from "./axisRole.interface";
import { axisRoleApis } from "./axisRole.service";

/** 특정 축(A/B/C)의 Role 중 첫 번째 값을 반환한다. 없으면 빈 문자열. */
export const getAxisRoleLabel = (roleMap: AxisRoleMap, axis: string) =>
  (roleMap[axis] ?? []).filter(Boolean)[0] ?? "";

export const useAxisRoleQuery = (
  draftArticleId = Number(getPressIdFromURL()),
) => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.axisRole, draftArticleId],
    queryFn: () => axisRoleApis.get(draftArticleId),
    select: ({ data }) => data,
    gcTime: 0,
    staleTime: 0,
  });
};
